<template>
  <modal :title="$t('public.history_data')" :visible.sync="isShowDialog" width="1000px">
    <div class="uk-flex uk-flex-middle">
      <span class="mr-5">{{$t('public.create_time')}}</span>
      <el-date-picker
          style="width:350px;"
          v-model="time"
          type="datetimerange"
          :range-separator="$t('public.to')"
          :start-placeholder="$t('public.start_date')"
          :end-placeholder="$t('public.end_date')"
          value-format="timestamp"
          align="right"
          @change="changeTime"
      >
      </el-date-picker>
      <div class="ml-5">
          <el-button type="primary" icon="el-icon-search" @click="getListFn"></el-button>
          <el-button icon="el-icon-refresh" @click="resetCondition"></el-button>
      </div>
    </div>
    <el-button
      type="primary"
      style="margin: 5px 0;"
      @click="delHistoryBatch"
    >
      {{ $t('public.btn_delete') }}
    </el-button>
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="50"
        align="center">
      </el-table-column>
      <el-table-column
        prop="name"
        :label="$t('public.file_name')"
        align="center">
      </el-table-column>
      <el-table-column
        :label=" $t('integration.file_type')"
        align="center">
          <template #default="{row}">
             {{ row.fileType === 1 ? 'PDF' : 'Excel' }}
          </template>
      </el-table-column>
      <el-table-column
        prop="genTime"
        :label="$t('public.create_time')"
        align="center">
        <template #default="{row}">
          {{ $timetransition(row.genTime)}}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('tableTitle.Operating')"
        width="100"
        align="center">
        <template #default="{row}">
          <i class="iconfont icon-download cursor-pointer mr-5" @click="download(row)"></i>
          <i class="el-icon-delete cursor-pointer" style="color: red;"  @click="delHistory(row)"></i>
        </template>
      </el-table-column>

    </el-table>
    <Pager
      ref="pagination"
      :total="total"
      :size="tableModel.iDisplayLength"
      @currentChange="currentChange"
    ></Pager>
  </modal>
</template>
<script>
import { getExportHistory, exportHisDownload, exportHisDelBatch } from "@/api/modules/export"
import Pager from '@/components/Pagination/src/Pager.vue'

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    taskId: {
      type: String | Number,
      default: null
    }
  },
  components: {
    Pager
  },
  data(){
    return {
      tableData: [],
      tableModel: {
        startTime: null,
        endTime: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      },
      multipleSelection: [],
      time: [],
      total: 0

    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
  },
  watch: {
    isShowDialog(){
      if(this.isShowDialog){
        this.getListFn()
      }
    }
  },
  created(){
    this.getListFn()
  },
  methods: {
    getListFn(){
      let params = {
        taskId: this.taskId,
        ...this.tableModel
      }
      getExportHistory(params).then(res => {
        const { pageInfo, result } = res
        this.total = pageInfo.total
        this.tableData = result
      })
    },
    resetCondition () {
     this.tableModel = {
        startTime: null,
        endTime: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      }
      this.time = []
      this.getListFn()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 批量删除
    async delHistoryBatch(){
      if(!this.multipleSelection.length){
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      let ids = this.multipleSelection.map(_ => _.id)
      await this.$confirm(
        this.$t(
          $t('integration.are_you_sure_you_want_to_perform_this_operation_q')
        )
      )
      await exportHisDelBatch(this.multipleSelection.map(item => item.id))
      this.getListFn()
    },
    // 单个删除
    delHistory(row){
      this.$confirm($t('integration.are_you_sure_you_want_to_delete_this_item')).then(() => {
        exportHisDelBatch([row.id]).then(({ state }) => {
          if (state.code === 200) {
            this.$message.success($t('integration.success'))
            this.getListFn()
          }
        })
      })
    },
    changeTime(e){
      console.log(e)
      console.log(this.time)
      this.tableModel.startTime = this.time ? this.time[0] : null
      this.tableModel.endTime = this.time ? this.time[1] : null
    },
    download(row){
      exportHisDownload({id: row.id}).then((res) => {

      })
    },
    currentChange ({ iDisplayStart, iDisplayLength }) {
      this.tableModel.iDisplayStart = iDisplayStart
      this.tableModel.iDisplayLength = iDisplayLength
      this.getListFn()
    },
  }
}
</script>
<style lang="scss" scoped>
.card-swiper {
  width: 150px;
  margin-right: 10px;
  .title {
    background-color: $theme-color;
  }
}
.countdown {
  display: inline-block;
}
::v-deep .uk-countdown {
  display: inline-block;
}
.uk-countdown-separator {
  font-size: 14px !important;
}
.uk-countdown-number {
  font-size: 14px !important;
}

</style>
